export default __webpack_public_path__ + "static/element-3.url-104fc35878f2ea12e65d0be0732632ac.svg";